
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { MuniSpinner2 } from "../../../components";
import { useEffect, useState } from "react";
import useActas from "../../../api/actas";
import useMotivos from "../../../api/motivos";
import { useMotivosStore } from "../../../store/motivosStore";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { bajaActaTribunalHandler } from "../../../handlers/opciones.handler";


const ModalBajaTribunal = ({ titleModal, titleMensaje, setRefetch, mensaje, variant, confirm }) => {
    const { modals, handlerModal, loads } = useGeneralAppStore();
    const { acta } = useActaDetalleStore()
    const { anularActa } = useActas()
    const { getMotivos } = useMotivos()
    const { motivos } = useMotivosStore();

    const [motivo, setMotivo] = useState("");
    const [opcionMotivo, setOpcionMotivo] = useState("No selecciono motivo");

    useEffect(() => {
        if (!motivos) {
            getMotivos();
        }
    }, [])

    // console.log(motivos)

    return (
        <>


            <Modal
                show={modals.includes('baja_tribunal')}
                onHide={() => handlerModal({ modal: false, modalName: "baja_tribunal" })}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{
                    backgroundColor: modals.length > 1 && modals[0] === 'acta_detalle' ? 'rgba(0,0,0,0.4)' : '',
                    // opacity: modals.length > 1 && modals[0] === 'acta_detalle' ? '.1' : '1',        
                }}
            // className="position-relative"
            >
                <div className="position-relative">
                    {
                        loads.includes('baja_tribunal') &&
                        <div className=" d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-3" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titleModal}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex flex-column gap-3">

                            {/* <h4 className="text-danger">{titleMensaje}</h4> */}
                            <Alert>Desea confirmar la baja del acta? <b>{acta.dependencia}-{acta.numero_infraccion}</b> </Alert>

                            {/* <Form.Select onChange={(e) => {
                                if (e.target.value == "") {
                                    setOpcionMotivo("No selecciono motivo")
                                } else {
                                    setOpcionMotivo(e.target.value)
                                }
                            }}>
                                <option value="">Seleccione motivo</option>
                                {
                                    motivos?.map((motivo) => (
                                        <option key={motivo.id} value={motivo.id}>{motivo.nombre}</option>
                                    ))
                                }
                            </Form.Select> */}


                            {/* <div className="d-flex gap-2">
                                <span className="fw-bold text-primary">Motivo:</span>
                                <span className={`${opcionMotivo == "No selecciono motivo" && "text-danger"} fw-medium`}>{opcionMotivo}</span>
                            </div> */}

                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        {/* <Button onClick={() => bajaActaTribunalHandler({ id: acta.id}, setRefetch)} >confirmar</Button> */}
                        <Button onClick={() => bajaActaTribunalHandler(acta.id, setRefetch)} >confirmar</Button>
                        <Button onClick={() => handlerModal({ modal: false, modalName: "baja_tribunal" })} variant="danger">cancelar</Button>
                    </Modal.Footer>
                </div>
            </Modal>


        </>
    );
}
export default ModalBajaTribunal;